<div class="table-wrapper">
  <div *ngIf="tableOrigin !== 'consolidated-extracts'" class="table-header">
    <div class="col data">Data</div>
    <div class="col descricao">Descrição</div>
    <div class="col entrada">Entradas</div>
    <div class="col saida">Saídas</div>
    <div class="col saldo" *ngIf="tableOrigin !== 'extract-scheduling'">Saldo</div>
    <div class="col acao"></div>
  </div>

  <ng-container *ngIf="tableOrigin === 'general-view'">
    <div class="dia-group" *ngFor="let grupo of data">
      <div class="table-row saldo-do-dia" *ngIf="grupo.data">
        <div class="col data">{{ grupo.data }}</div>
        <div class="col descricao">
          Saldo do dia
        </div>
        <div class="col entrada">-</div>
        <div class="col saida">-</div>
        <div class="col saldo">
          {{ grupo.total | currency : "BRL" }}
        </div>
        <div class="col acao">
        </div>
      </div>

      <div class="table-row" *ngFor="let t of grupo.lancamentos">
        <div class="col data"></div>
        <div class="col descricao">
          <div
            class="tipo-icone"
            [ngClass]="t.natureza === 'C' ? 'entrada' : 'saida'"
          >
            ⇄
          </div>
          <div class="descricao-texto">
            <div class="titulo">{{ t.descHistorico | uppercase }}</div>
            <div class="detalhe">{{ t.compHistorico | uppercase }}</div>
          </div>
        </div>
        <div class="col entrada">
          {{ t.natureza === "C" ? (t.valorLcto | currency:'BRL':'symbol') : "-" }}
        </div>
        <div class="col saida">
          {{ t.natureza === "D" ? (t.valorLcto | currency:'BRL':'symbol') : "-" }}
        </div>
        <div class="col saldo"></div>
        <div class="col acao" (click)="getBalanceDetails(t)">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.2 11.6C7.2 12.4837 6.48366 13.2 5.6 13.2C4.71634 13.2 4 12.4837 4 11.6C4 10.7163 4.71634 10 5.6 10C6.48366 10 7.2 10.7163 7.2 11.6ZM13.6 11.6C13.6 12.4837 12.8837 13.2 12 13.2C11.1164 13.2 10.4 12.4837 10.4 11.6C10.4 10.7163 11.1164 10 12 10C12.8837 10 13.6 10.7163 13.6 11.6ZM18.4 13.2C19.2837 13.2 20 12.4837 20 11.6C20 10.7163 19.2837 10 18.4 10C17.5164 10 16.8 10.7163 16.8 11.6C16.8 12.4837 17.5164 13.2 18.4 13.2Z"
              fill="#4D86BF"
            />
          </svg>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="tableOrigin === 'extract-scheduling'">
    <div class="dia-group" *ngFor="let grupo of data">
      <div class="table-row" *ngFor="let t of grupo.lancamentos">
        <div class="col data">{{ grupo.data | date: 'dd/MM/yyyy' }}</div>
        <div class="col descricao">
          <div
            class="tipo-icone"
            [ngClass]="t.cod_deb_cred === 'C' ? 'entrada' : 'saida'"
          >
            ⇄
          </div>
          <div class="descricao-texto">
            <div class="titulo">{{ t.desc_historico | uppercase }}</div>
            <div class="detalhe">{{ t.nome_favorecido | uppercase }}</div>
          </div>
        </div>
        <div class="col entrada">
          {{ t.cod_deb_cred === "C" ? (t.vlr_lancamento | currency:'BRL':'symbol') : "-" }}
        </div>
        <div class="col saida">
          {{ t.cod_deb_cred === "D" ? (t.vlr_lancamento | currency:'BRL':'symbol') : "-" }}
        </div>
        <div class="col acao" (click)="getBalanceDetails(t, grupo.data)">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.2 11.6C7.2 12.4837 6.48366 13.2 5.6 13.2C4.71634 13.2 4 12.4837 4 11.6C4 10.7163 4.71634 10 5.6 10C6.48366 10 7.2 10.7163 7.2 11.6ZM13.6 11.6C13.6 12.4837 12.8837 13.2 12 13.2C11.1164 13.2 10.4 12.4837 10.4 11.6C10.4 10.7163 11.1164 10 12 10C12.8837 10 13.6 10.7163 13.6 11.6ZM18.4 13.2C19.2837 13.2 20 12.4837 20 11.6C20 10.7163 19.2837 10 18.4 10C17.5164 10 16.8 10.7163 16.8 11.6C16.8 12.4837 17.5164 13.2 18.4 13.2Z"
              fill="#4D86BF"
            />
          </svg>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="tableOrigin === 'consolidated-extracts'">
    <div class="dia-group">
      <div class="table-row-consolidated">
        <div class="col month">Março/2025</div>
        <div class="col button-action">
          <bfd-badge
            [title]="'Extrato parcial'"
            [type]="'outline-alert'"
          ></bfd-badge>
        </div>
        <div class="col button-action">
          <bfd-button
            [text]="'Baixar extrato'"
            [loading]="loading"
            [disabled]="false"
            [type]="'terniary-large'"
            (buttonClick)="limitIncrease($event)"
          >
          </bfd-button>
        </div>
      </div>
    </div>
  </ng-container>
</div>
